export const useHeaderStore = defineStore('StoreHeader', {
    state: () => ({
        menuOpen: false,
    }),
    actions: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        closeMenu() {
            this.menuOpen = false;
        },
    },
});
